// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --appBlack: #000000;
  --inactiveIcon: #8a8c91;
  --activeIcon: white;
  --activeIconRed: red;
  --popupBackground: #2d2f39;
  --legendRed: #e72416;
  --legendYellow: #ffe08f;
  --frontBlue: #0178ae;
  --legendGreen: #83b643;
  --lighterGreen: #8cff0053;
  --textDetails: #ec6728;
  --inputError: #d60d25;
  --inputSuccess: #12b76a;
  --statusBlue: #3f7bf3;
  --sectionHeadlineText: #54778e;
  --sfOrangeLight: #ff8e58;
  --badgeBg: #f7ddd0;
}

.BulkInternalNotes-module_root___U68LX {
  width: 1200px;
  max-width: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
}

.BulkInternalNotes-module_top___SzvWF {
  display: flex;
  padding: 2rem 0;
  overflow: auto;
}
@media (max-width: 900px) {
  .BulkInternalNotes-module_top___SzvWF {
    flex-direction: column;
  }
}

.BulkInternalNotes-module_left___LID7C {
  flex: 1.2;
  min-width: 320px;
  padding: 2rem 2rem 0 2rem;
  user-select: none;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.theme--light .BulkInternalNotes-module_left___LID7C {
  border-right: 1px solid #dddddd;
}
.theme--dark .BulkInternalNotes-module_left___LID7C {
  border-right: 1px solid #2f2f2f;
}

.BulkInternalNotes-module_right___JsN5e {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 420px;
  padding: 2rem 2rem 0 2rem;
}

.BulkInternalNotes-module_section___TN2QT {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.theme--light .BulkInternalNotes-module_subHeader___wRi7j {
  color: #212121;
  font-size: 1.6rem;
  font-weight: 600;
}
.theme--dark .BulkInternalNotes-module_subHeader___wRi7j {
  color: #f0f0f0;
  font-size: 1.6rem;
  font-weight: 600;
}

.theme--light .BulkInternalNotes-module_subHeaderSecondary___p1A5j {
  color: #888888;
  font-size: 1.3rem;
}
.theme--dark .BulkInternalNotes-module_subHeaderSecondary___p1A5j {
  color: #a3a3a3;
  font-size: 1.3rem;
}

.BulkInternalNotes-module_description___kpNEH {
  font-size: 1.2rem;
}
.theme--light .BulkInternalNotes-module_description___kpNEH {
  color: #888888;
}
.theme--dark .BulkInternalNotes-module_description___kpNEH {
  color: #a3a3a3;
}

.BulkInternalNotes-module_label___HzeWK {
  font-weight: 500;
  font-size: 1.2rem;
  margin-bottom: 6px;
}
.theme--light .BulkInternalNotes-module_label___HzeWK {
  color: #888888;
}
.theme--dark .BulkInternalNotes-module_label___HzeWK {
  color: #a3a3a3;
}

.BulkInternalNotes-module_fieldsGrid___GyYY6 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.BulkInternalNotes-module_maskedFieldsRow___hIDwx {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
}

.BulkInternalNotes-module_field___p4pDW {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.BulkInternalNotes-module_fieldFull___xcyVw {
  grid-column: 1/-1;
}

.BulkInternalNotes-module_input___DJmbK {
  width: 100%;
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 1.3rem;
  font-family: inherit;
}
.theme--light .BulkInternalNotes-module_input___DJmbK {
  border: 1px solid #dddddd;
  background-color: #ffffff;
  color: #212121;
}
.theme--light .BulkInternalNotes-module_input___DJmbK::placeholder {
  color: #888888;
}
.theme--dark .BulkInternalNotes-module_input___DJmbK {
  border: 1px solid #2f2f2f;
  background-color: #1c1c1c;
  color: #f0f0f0;
}
.theme--dark .BulkInternalNotes-module_input___DJmbK::placeholder {
  color: #a3a3a3;
}
.BulkInternalNotes-module_input___DJmbK:focus {
  outline: none;
}
.theme--light .BulkInternalNotes-module_input___DJmbK:focus {
  border-color: #212121;
}
.theme--dark .BulkInternalNotes-module_input___DJmbK:focus {
  border-color: #f0f0f0;
}

.BulkInternalNotes-module_textArea___wXnvd, .BulkInternalNotes-module_smallTextArea___S0_66 {
  width: 100%;
  border-radius: 6px;
  min-height: 140px;
  padding: 10px 12px;
  font-size: 1.3rem;
  line-height: 1.5;
  font-family: inherit;
  resize: vertical;
}
.theme--light .BulkInternalNotes-module_textArea___wXnvd, .theme--light .BulkInternalNotes-module_smallTextArea___S0_66 {
  border: 1px solid #dddddd;
  background-color: #ffffff;
  color: #212121;
}
.theme--light .BulkInternalNotes-module_textArea___wXnvd::placeholder, .theme--light .BulkInternalNotes-module_smallTextArea___S0_66::placeholder {
  color: #888888;
}
.theme--dark .BulkInternalNotes-module_textArea___wXnvd, .theme--dark .BulkInternalNotes-module_smallTextArea___S0_66 {
  border: 1px solid #2f2f2f;
  background-color: #1c1c1c;
  color: #f0f0f0;
}
.theme--dark .BulkInternalNotes-module_textArea___wXnvd::placeholder, .theme--dark .BulkInternalNotes-module_smallTextArea___S0_66::placeholder {
  color: #a3a3a3;
}
.BulkInternalNotes-module_textArea___wXnvd:focus, .BulkInternalNotes-module_smallTextArea___S0_66:focus {
  outline: none;
}
.theme--light .BulkInternalNotes-module_textArea___wXnvd:focus, .theme--light .BulkInternalNotes-module_smallTextArea___S0_66:focus {
  border-color: #212121;
}
.theme--dark .BulkInternalNotes-module_textArea___wXnvd:focus, .theme--dark .BulkInternalNotes-module_smallTextArea___S0_66:focus {
  border-color: #f0f0f0;
}

.BulkInternalNotes-module_smallTextArea___S0_66 {
  min-height: 70px;
}

.BulkInternalNotes-module_toggles___H84m2 {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.BulkInternalNotes-module_toggle___YGnCM {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.theme--light .BulkInternalNotes-module_toggle___YGnCM {
  border: 1px solid #dddddd;
  border-radius: 6px;
  padding: 8px 12px;
  background-color: #ffffff;
}
.theme--dark .BulkInternalNotes-module_toggle___YGnCM {
  border: 1px solid #2f2f2f;
  border-radius: 6px;
  padding: 8px 12px;
  background-color: #1c1c1c;
}

.theme--light .BulkInternalNotes-module_warning___lUQDp {
  border: 1px solid #fecdca;
  background: #fef3f2;
  color: #b42318;
  padding: 1.6rem;
  border-radius: 6px;
}
.theme--dark .BulkInternalNotes-module_warning___lUQDp {
  border: 1px solid #fecdca;
  background: #fef3f2;
  color: #b42318;
  padding: 1.6rem;
  border-radius: 6px;
}

.BulkInternalNotes-module_warningHeader___I1VAD {
  font-size: 1.4rem;
  font-weight: 600;
}

.BulkInternalNotes-module_warningText___sbMQE {
  font-size: 1.2rem;
  font-weight: 400;
}

.BulkInternalNotes-module_rightTopHeaders___rwKcv {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-bottom: 1.6rem;
}
.theme--light .BulkInternalNotes-module_rightTopHeaders___rwKcv {
  border-bottom: 1px solid #dddddd;
}
.theme--dark .BulkInternalNotes-module_rightTopHeaders___rwKcv {
  border-bottom: 1px solid #2f2f2f;
}

.BulkInternalNotes-module_summaryRow___piPEv {
  font-size: 1.2rem;
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.theme--light .BulkInternalNotes-module_summaryRow___piPEv {
  color: #888888;
}
.theme--dark .BulkInternalNotes-module_summaryRow___piPEv {
  color: #a3a3a3;
}

.BulkInternalNotes-module_summaryRowLabel___LTip3 {
  font-weight: 500;
}

.BulkInternalNotes-module_summaryRowValue___kv5WA {
  font-weight: 500;
}
.theme--light .BulkInternalNotes-module_summaryRowValue___kv5WA {
  color: #212121;
}
.theme--dark .BulkInternalNotes-module_summaryRowValue___kv5WA {
  color: #f0f0f0;
}

.BulkInternalNotes-module_summaryRowValuePositive___K1whH {
  font-weight: 500;
}
.theme--light .BulkInternalNotes-module_summaryRowValuePositive___K1whH {
  color: #212121;
}
.theme--dark .BulkInternalNotes-module_summaryRowValuePositive___K1whH {
  color: #f0f0f0;
}

.BulkInternalNotes-module_summaryRowValueDisabled___DPSF9 {
  font-weight: 500;
}
.theme--light .BulkInternalNotes-module_summaryRowValueDisabled___DPSF9 {
  color: #888888;
}
.theme--dark .BulkInternalNotes-module_summaryRowValueDisabled___DPSF9 {
  color: #a3a3a3;
}

.BulkInternalNotes-module_buttons___SUKFp {
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  padding: 2rem;
}
.theme--light .BulkInternalNotes-module_buttons___SUKFp {
  border-top: 1px solid #dddddd;
}
.theme--dark .BulkInternalNotes-module_buttons___SUKFp {
  border-top: 1px solid #2f2f2f;
}

.BulkInternalNotes-module_listings___RggLu {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  overflow: auto;
}

.BulkInternalNotes-module_singleListing___LRiH0 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 6px;
  padding: 6px;
  font-size: 1.4rem;
}
.theme--light .BulkInternalNotes-module_singleListing___LRiH0 {
  border-top: 1px solid #dddddd;
}
.theme--dark .BulkInternalNotes-module_singleListing___LRiH0 {
  border-top: 1px solid #2f2f2f;
}

.BulkInternalNotes-module_singleListing___LRiH0[data-no-border=true] {
  border: none;
}

.BulkInternalNotes-module_xContainer___YucWz {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  cursor: pointer;
  width: 30px;
  align-self: stretch;
}
.BulkInternalNotes-module_xContainer___YucWz div {
  display: flex;
  align-items: center;
  padding: 2px;
  justify-content: center;
  border-radius: 6px;
  transition: 200ms;
}
.theme--light .BulkInternalNotes-module_xContainer___YucWz div {
  background: #dddddd;
}
.theme--dark .BulkInternalNotes-module_xContainer___YucWz div {
  background: #2f2f2f;
}
.theme--light .BulkInternalNotes-module_xContainer___YucWz div:hover {
  background: #888888;
}
.theme--dark .BulkInternalNotes-module_xContainer___YucWz div:hover {
  background: #a3a3a3;
}

.BulkInternalNotes-module_itemTextPrimary___vxEK9 {
  font-size: 1.4rem;
  font-weight: 500;
}

.BulkInternalNotes-module_secRowSeat___tTzRG {
  flex-grow: 1;
  min-width: 20px;
}

.BulkInternalNotes-module_headerSecRowSeat___TIs3u {
  padding: 0.6rem;
}

.BulkInternalNotes-module_secRowSeatCont___j26Zj {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.BulkInternalNotes-module_textSecondary___DAKEq {
  font-size: 1.2rem;
  font-weight: 400;
}
.theme--light .BulkInternalNotes-module_textSecondary___DAKEq {
  color: #888888;
}
.theme--dark .BulkInternalNotes-module_textSecondary___DAKEq {
  color: #a3a3a3;
}

.BulkInternalNotes-module_qty____XE1Z {
  width: 45px;
  padding: 0.6rem;
  flex-shrink: 0;
}
.theme--light .BulkInternalNotes-module_qty____XE1Z {
  color: #888888;
}
.theme--dark .BulkInternalNotes-module_qty____XE1Z {
  color: #a3a3a3;
}

.BulkInternalNotes-module_costLabel___HFpli {
  width: 90px;
  padding: 0.6rem;
  flex-shrink: 0;
  text-align: right;
}
.theme--light .BulkInternalNotes-module_costLabel___HFpli {
  color: #888888;
}
.theme--dark .BulkInternalNotes-module_costLabel___HFpli {
  color: #a3a3a3;
}

.BulkInternalNotes-module_loaderWrapper___q80Go {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 520px;
  width: 1200px;
  max-width: 100%;
}

.BulkInternalNotes-module_inputWithAction___XW2vF {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.BulkInternalNotes-module_copyButton___ZFGkb {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border-radius: 6px;
  cursor: pointer;
  background: none;
}
.theme--light .BulkInternalNotes-module_copyButton___ZFGkb {
  border: 1px solid #dddddd;
  color: #888888;
}
.theme--dark .BulkInternalNotes-module_copyButton___ZFGkb {
  border: 1px solid #2f2f2f;
  color: #a3a3a3;
}
.BulkInternalNotes-module_copyButton___ZFGkb:disabled {
  cursor: default;
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/styles/_index.scss","webpack://./src/components/bulkInternalNotes/BulkInternalNotes.module.scss"],"names":[],"mappings":"AAOA;EACC,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0BAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,8BAAA;EACA,wBAAA;EACA,kBAAA;ACND;;AAhBA;EACC,aAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAmBD;;AAhBA;EACC,aAAA;EACA,eAAA;EACA,cAAA;AAmBD;AAjBC;EALD;IAME,sBAAA;EAoBA;AACF;;AAjBA;EAKC,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAgBD;ADyDE;EClFA,+BAAA;AA4BF;ADsDE;EClFA,+BAAA;AA+BF;;AAnBA;EACC,OAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;AAsBD;;AAnBA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AAsBD;;ADoCE;ECrDA,cAAA;EACA,iBAAA;EACA,gBAAA;AAqBF;AD8BE;ECrDA,cAAA;EACA,iBAAA;EACA,gBAAA;AA0BF;;ADyBE;EC7CA,cAAA;EACA,iBAAA;AAwBF;ADoBE;EC7CA,cAAA;EACA,iBAAA;AA4BF;;AAxBA;EAKC,iBAAA;AAuBD;ADYE;ECtCA,cAAA;AA6BF;ADSE;ECtCA,cAAA;AAgCF;;AA1BA;EACC,gBAAA;EACA,iBAAA;EACA,kBAAA;AA6BD;ADAE;EC1BA,cAAA;AA6BF;ADHE;EC1BA,cAAA;AAgCF;;AA5BA;EACC,aAAA;EACA,gDAAA;EACA,SAAA;AA+BD;;AA5BA;EACC,aAAA;EACA,2DAAA;EACA,SAAA;AA+BD;;AA5BA;EACC,aAAA;EACA,sBAAA;EACA,YAAA;AA+BD;;AA5BA;EACC,iBAAA;AA+BD;;AA5BA;EAWC,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AAqBD;ADpCE;ECEA,yBAAA;EACA,yBAAA;EACA,cAAA;AAqCF;AAnCE;EACC,cAAA;AAqCH;AD5CE;ECEA,yBAAA;EACA,yBAAA;EACA,cAAA;AA6CF;AA3CE;EACC,cAAA;AA6CH;AAnCC;EACC,aAAA;AAqCF;ADvDE;ECoBC,qBAAA;AAsCH;AD1DE;ECoBC,qBAAA;AAyCH;;AApCA;EAWC,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;AA6BD;ADxEE;EC2BA,yBAAA;EACA,yBAAA;EACA,cAAA;AAgDF;AA9CE;EACC,cAAA;AAgDH;ADhFE;EC2BA,yBAAA;EACA,yBAAA;EACA,cAAA;AAwDF;AAtDE;EACC,cAAA;AAwDH;AA3CC;EACC,aAAA;AA6CF;AD3FE;ECgDC,qBAAA;AA8CH;AD9FE;ECgDC,qBAAA;AAiDH;;AA5CA;EAEC,gBAAA;AA8CD;;AA3CA;EACC,aAAA;EACA,eAAA;EACA,QAAA;AA8CD;;AA3CA;EAQC,aAAA;EACA,mBAAA;EACA,eAAA;AAuCD;ADjHE;ECkEA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;AAkDF;ADvHE;ECkEA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;AAwDF;;AD7HE;EC+EA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAkDF;ADrIE;EC+EA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAyDF;;AArDA;EACC,iBAAA;EACA,gBAAA;AAwDD;;AArDA;EACC,iBAAA;EACA,gBAAA;AAwDD;;AArDA;EAKC,aAAA;EACA,sBAAA;EACA,QAAA;EACA,sBAAA;AAoDD;AD7JE;ECmGA,gCAAA;AA6DF;ADhKE;ECmGA,gCAAA;AAgEF;;AAvDA;EAKC,iBAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;AAsDD;AD1KE;EC8GA,cAAA;AA+DF;AD7KE;EC8GA,cAAA;AAkEF;;AAzDA;EACC,gBAAA;AA4DD;;AAzDA;EAKC,gBAAA;AAwDD;ADxLE;EC6HA,cAAA;AA8DF;AD3LE;EC6HA,cAAA;AAiEF;;AA3DA;EAKC,gBAAA;AA0DD;ADlME;ECqIA,cAAA;AAgEF;ADrME;ECqIA,cAAA;AAmEF;;AA7DA;EAKC,gBAAA;AA4DD;AD5ME;EC6IA,cAAA;AAkEF;AD/ME;EC6IA,cAAA;AAqEF;;AA/DA;EAKC,aAAA;EACA,SAAA;EACA,yBAAA;EACA,aAAA;AA8DD;ADzNE;ECqJA,6BAAA;AAuEF;AD5NE;ECqJA,6BAAA;AA0EF;;AAjEA;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;AAoED;;AAjEA;EAKC,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAgED;AD/OE;ECuKA,6BAAA;AA2EF;ADlPE;ECuKA,6BAAA;AA8EF;;AAnEA;EACC,YAAA;AAsED;;AAnEA;EACC,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AAsED;AApEC;EAKC,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;AAkEF;AD1QE;ECgMC,mBAAA;AA6EH;AD7QE;ECgMC,mBAAA;AAgFH;ADhRE;EC6MC,mBAAA;AAsEH;ADnRE;EC6MC,mBAAA;AAyEH;;AApEA;EACC,iBAAA;EACA,gBAAA;AAuED;;AApEA;EACC,YAAA;EACA,eAAA;AAuED;;AApEA;EACC,eAAA;AAuED;;AApEA;EACC,aAAA;EACA,sBAAA;EACA,QAAA;AAuED;;AApEA;EACC,iBAAA;EACA,gBAAA;AAuED;AD/SE;EC2OA,cAAA;AAuEF;ADlTE;EC2OA,cAAA;AA0EF;;AAtEA;EAKC,WAAA;EACA,eAAA;EACA,cAAA;AAqED;AD3TE;ECiPA,cAAA;AA6EF;AD9TE;ECiPA,cAAA;AAgFF;;AAxEA;EAKC,WAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AAuED;ADxUE;EC2PA,cAAA;AAgFF;AD3UE;EC2PA,cAAA;AAmFF;;AA1EA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AA6ED;;AA1EA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AA6ED;;AA1EA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AA6ED;AD1WE;ECgSA,yBAAA;EACA,cAAA;AA6EF;AD9WE;ECgSA,yBAAA;EACA,cAAA;AAiFF;AA9EC;EACC,eAAA;EACA,YAAA;AAgFF","sourcesContent":["@use \"sass:map\";\r\n\r\n$breakPointM: 1024px;\r\n$breakPointS: 768px;\r\n$breakPointHeightL: 900px;\r\n$breakPointHeightXL: 2200px;\r\n\r\n:root {\r\n\t--appBlack: #000000;\r\n\t--inactiveIcon: #8a8c91;\r\n\t--activeIcon: white;\r\n\t--activeIconRed: red;\r\n\t--popupBackground: #2d2f39;\r\n\t--legendRed: #e72416;\r\n\t--legendYellow: #ffe08f;\r\n\t--frontBlue: #0178ae;\r\n\t--legendGreen: #83b643;\r\n\t--lighterGreen: #8cff0053;\r\n\t--textDetails: #ec6728;\r\n\t--inputError: #d60d25;\r\n\t--inputSuccess: #12b76a;\r\n\t--statusBlue: #3f7bf3;\r\n\t--sectionHeadlineText: #54778e;\r\n\t--sfOrangeLight: #ff8e58;\r\n\t--badgeBg: #f7ddd0;\r\n}\r\n\r\n$themes: (\r\n\tlight: (\r\n\t\tbackgroundPrimary: #f5f6f8,\r\n\t\tsidebarBorder: #dddddd,\r\n\t\ttextPrimary: #212121,\r\n\t\trowWithSoldColor: #212121,\r\n\t\ttextSecondary: #888888,\r\n\t\tborderColor: #dddddd,\r\n\t\tbuttonTertiaryBackground: #ffffff,\r\n\t\tbuttonTertiaryColor: #1f1f1f,\r\n\t\tbuttonTertiaryBorderColor: #e8e8e8,\r\n\t\tinputBackground: #fafafa,\r\n\t\tinputBorderColor: #ddddda,\r\n\t\tsectionBackground: #ffffff,\r\n\t\ttableCellBackground: #ffffff,\r\n\t\ttableHeaderBackground: #f5f6f8,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #cfe1cb,\r\n\t\tholdHighlightedItem: #fff3c4,\r\n\t\trowWithHoldColor: #212121,\r\n\r\n\t\tbuttonPrimaryBackground: #000000,\r\n\t\tbuttonPrimaryBorderColor: #555555,\r\n\t\tbuttonPrimaryTextColor: #ffffff,\r\n\r\n\t\tbuttonSecondaryBackground: #ffffff,\r\n\t\tbuttonSecondaryBorderColor: #dddddd,\r\n\t\tbuttonSecondaryTextColor: #000000,\r\n\r\n\t\tsidebarBackground: #ffffff,\r\n\t\tbuttonOutlineBorder: #8b8b8b,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n\tdark: (\r\n\t\tbackgroundPrimary: #0d0d0d,\r\n\t\tsidebarBorder: #000000,\r\n\t\ttextPrimary: #f0f0f0,\r\n\t\trowWithSoldColor: #f0f0f0,\r\n\t\ttextSecondary: #a3a3a3,\r\n\t\tborderColor: #2f2f2f,\r\n\t\tbuttonTertiaryBackground: #0d0d0d,\r\n\t\tbuttonTertiaryColor: #fafafa,\r\n\t\tbuttonTertiaryBorderColor: #2f2f2f,\r\n\t\tinputBackground: #0d0d0d,\r\n\t\tinputBorderColor: #2f2f2f,\r\n\t\tsectionBackground: #1c1c1c,\r\n\t\ttableCellBackground: #1c1c1c,\r\n\t\ttableHeaderBackground: #1c1c1c,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #4a5c46,\r\n\t\tholdHighlightedItem: #5c5630,\r\n\t\trowWithHoldColor: #f0f0f0,\r\n\r\n\t\tbuttonPrimaryBackground: #ffffff,\r\n\t\tbuttonPrimaryBorderColor: #dddddd,\r\n\t\tbuttonPrimaryTextColor: #000000,\r\n\r\n\t\tbuttonSecondaryBackground: #000000,\r\n\t\tbuttonSecondaryBorderColor: #555555,\r\n\t\tbuttonSecondaryTextColor: #ffffff,\r\n\r\n\t\tsidebarBackground: #000000,\r\n\t\tbuttonOutlineBorder: #dddddd,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n);\r\n\r\n@mixin themed {\r\n\t@each $theme, $map in $themes {\r\n\t\t:global(.theme--#{$theme}) & {\r\n\t\t\t$theme-map: () !global;\r\n\t\t\t@each $key, $submap in $map {\r\n\t\t\t\t$value: map.get($map, $key);\r\n\t\t\t\t$theme-map: map.merge(\r\n\t\t\t\t\t$theme-map,\r\n\t\t\t\t\t(\r\n\t\t\t\t\t\t$key: $value,\r\n\t\t\t\t\t)\r\n\t\t\t\t) !global;\r\n\t\t\t}\r\n\t\t\t@content;\r\n\t\t\t$theme-map: null !global;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@function get($key) {\r\n\t@return map-get($theme-map, $key);\r\n}\r\n\r\n@mixin button-primary {\r\n\tbackground: linear-gradient(135deg, var(--textDetails), #e45210);\r\n\tcolor: white;\r\n\tborder: none;\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: linear-gradient(135deg, #e45210, #d3470e);\r\n\t\ttransform: translateY(-2px);\r\n\t}\r\n}\r\n\r\n@mixin button-secondary {\r\n\t@include themed {\r\n\t\tbackground: get(\"buttonTertiaryBackground\");\r\n\t\tcolor: get(\"buttonTertiaryColor\");\r\n\t\tborder: 1px solid get(\"buttonTertiaryBorderColor\");\r\n\t}\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: var(--textDetails);\r\n\t\tcolor: white;\r\n\t\tborder-color: var(--textDetails);\r\n\t}\r\n}\r\n\r\n@mixin card {\r\n\t@include themed {\r\n\t\tbackground: get(\"sectionBackground\");\r\n\t\tborder: 1px solid get(\"borderColor\");\r\n\t}\r\n\tborder-radius: 12px;\r\n\tpadding: 24px;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\ttransform: translateY(-4px);\r\n\t\tbox-shadow: 0 8px 32px rgba(245, 99, 28, 0.1);\r\n\t}\r\n}\r\n\r\n@mixin section-padding {\r\n\tpadding: 50px 0;\r\n\tborder-radius: 12px;\r\n}\r\n\r\n@mixin container {\r\n\tmax-width: 1200px;\r\n\tpadding: 0 24px;\r\n}\r\n",":root {\n  --appBlack: #000000;\n  --inactiveIcon: #8a8c91;\n  --activeIcon: white;\n  --activeIconRed: red;\n  --popupBackground: #2d2f39;\n  --legendRed: #e72416;\n  --legendYellow: #ffe08f;\n  --frontBlue: #0178ae;\n  --legendGreen: #83b643;\n  --lighterGreen: #8cff0053;\n  --textDetails: #ec6728;\n  --inputError: #d60d25;\n  --inputSuccess: #12b76a;\n  --statusBlue: #3f7bf3;\n  --sectionHeadlineText: #54778e;\n  --sfOrangeLight: #ff8e58;\n  --badgeBg: #f7ddd0;\n}\n\n.root {\n  width: 1200px;\n  max-width: 100%;\n  max-height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.top {\n  display: flex;\n  padding: 2rem 0;\n  overflow: auto;\n}\n@media (max-width: 900px) {\n  .top {\n    flex-direction: column;\n  }\n}\n\n.left {\n  flex: 1.2;\n  min-width: 320px;\n  padding: 2rem 2rem 0 2rem;\n  user-select: none;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n:global(.theme--light) .left {\n  border-right: 1px solid #dddddd;\n}\n:global(.theme--dark) .left {\n  border-right: 1px solid #2f2f2f;\n}\n\n.right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  min-width: 420px;\n  padding: 2rem 2rem 0 2rem;\n}\n\n.section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n:global(.theme--light) .subHeader {\n  color: #212121;\n  font-size: 1.6rem;\n  font-weight: 600;\n}\n:global(.theme--dark) .subHeader {\n  color: #f0f0f0;\n  font-size: 1.6rem;\n  font-weight: 600;\n}\n\n:global(.theme--light) .subHeaderSecondary {\n  color: #888888;\n  font-size: 1.3rem;\n}\n:global(.theme--dark) .subHeaderSecondary {\n  color: #a3a3a3;\n  font-size: 1.3rem;\n}\n\n.description {\n  font-size: 1.2rem;\n}\n:global(.theme--light) .description {\n  color: #888888;\n}\n:global(.theme--dark) .description {\n  color: #a3a3a3;\n}\n\n.label {\n  font-weight: 500;\n  font-size: 1.2rem;\n  margin-bottom: 6px;\n}\n:global(.theme--light) .label {\n  color: #888888;\n}\n:global(.theme--dark) .label {\n  color: #a3a3a3;\n}\n\n.fieldsGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.maskedFieldsRow {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 12px;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.fieldFull {\n  grid-column: 1/-1;\n}\n\n.input {\n  width: 100%;\n  border-radius: 6px;\n  padding: 10px 12px;\n  font-size: 1.3rem;\n  font-family: inherit;\n}\n:global(.theme--light) .input {\n  border: 1px solid #dddddd;\n  background-color: #ffffff;\n  color: #212121;\n}\n:global(.theme--light) .input::placeholder {\n  color: #888888;\n}\n:global(.theme--dark) .input {\n  border: 1px solid #2f2f2f;\n  background-color: #1c1c1c;\n  color: #f0f0f0;\n}\n:global(.theme--dark) .input::placeholder {\n  color: #a3a3a3;\n}\n.input:focus {\n  outline: none;\n}\n:global(.theme--light) .input:focus {\n  border-color: #212121;\n}\n:global(.theme--dark) .input:focus {\n  border-color: #f0f0f0;\n}\n\n.textArea, .smallTextArea {\n  width: 100%;\n  border-radius: 6px;\n  min-height: 140px;\n  padding: 10px 12px;\n  font-size: 1.3rem;\n  line-height: 1.5;\n  font-family: inherit;\n  resize: vertical;\n}\n:global(.theme--light) .textArea, :global(.theme--light) .smallTextArea {\n  border: 1px solid #dddddd;\n  background-color: #ffffff;\n  color: #212121;\n}\n:global(.theme--light) .textArea::placeholder, :global(.theme--light) .smallTextArea::placeholder {\n  color: #888888;\n}\n:global(.theme--dark) .textArea, :global(.theme--dark) .smallTextArea {\n  border: 1px solid #2f2f2f;\n  background-color: #1c1c1c;\n  color: #f0f0f0;\n}\n:global(.theme--dark) .textArea::placeholder, :global(.theme--dark) .smallTextArea::placeholder {\n  color: #a3a3a3;\n}\n.textArea:focus, .smallTextArea:focus {\n  outline: none;\n}\n:global(.theme--light) .textArea:focus, :global(.theme--light) .smallTextArea:focus {\n  border-color: #212121;\n}\n:global(.theme--dark) .textArea:focus, :global(.theme--dark) .smallTextArea:focus {\n  border-color: #f0f0f0;\n}\n\n.smallTextArea {\n  min-height: 70px;\n}\n\n.toggles {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.toggle {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n:global(.theme--light) .toggle {\n  border: 1px solid #dddddd;\n  border-radius: 6px;\n  padding: 8px 12px;\n  background-color: #ffffff;\n}\n:global(.theme--dark) .toggle {\n  border: 1px solid #2f2f2f;\n  border-radius: 6px;\n  padding: 8px 12px;\n  background-color: #1c1c1c;\n}\n\n:global(.theme--light) .warning {\n  border: 1px solid #fecdca;\n  background: #fef3f2;\n  color: #b42318;\n  padding: 1.6rem;\n  border-radius: 6px;\n}\n:global(.theme--dark) .warning {\n  border: 1px solid #fecdca;\n  background: #fef3f2;\n  color: #b42318;\n  padding: 1.6rem;\n  border-radius: 6px;\n}\n\n.warningHeader {\n  font-size: 1.4rem;\n  font-weight: 600;\n}\n\n.warningText {\n  font-size: 1.2rem;\n  font-weight: 400;\n}\n\n.rightTopHeaders {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding-bottom: 1.6rem;\n}\n:global(.theme--light) .rightTopHeaders {\n  border-bottom: 1px solid #dddddd;\n}\n:global(.theme--dark) .rightTopHeaders {\n  border-bottom: 1px solid #2f2f2f;\n}\n\n.summaryRow {\n  font-size: 1.2rem;\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n:global(.theme--light) .summaryRow {\n  color: #888888;\n}\n:global(.theme--dark) .summaryRow {\n  color: #a3a3a3;\n}\n\n.summaryRowLabel {\n  font-weight: 500;\n}\n\n.summaryRowValue {\n  font-weight: 500;\n}\n:global(.theme--light) .summaryRowValue {\n  color: #212121;\n}\n:global(.theme--dark) .summaryRowValue {\n  color: #f0f0f0;\n}\n\n.summaryRowValuePositive {\n  font-weight: 500;\n}\n:global(.theme--light) .summaryRowValuePositive {\n  color: #212121;\n}\n:global(.theme--dark) .summaryRowValuePositive {\n  color: #f0f0f0;\n}\n\n.summaryRowValueDisabled {\n  font-weight: 500;\n}\n:global(.theme--light) .summaryRowValueDisabled {\n  color: #888888;\n}\n:global(.theme--dark) .summaryRowValueDisabled {\n  color: #a3a3a3;\n}\n\n.buttons {\n  display: flex;\n  gap: 16px;\n  justify-content: flex-end;\n  padding: 2rem;\n}\n:global(.theme--light) .buttons {\n  border-top: 1px solid #dddddd;\n}\n:global(.theme--dark) .buttons {\n  border-top: 1px solid #2f2f2f;\n}\n\n.listings {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n  overflow: auto;\n}\n\n.singleListing {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  border-radius: 6px;\n  padding: 6px;\n  font-size: 1.4rem;\n}\n:global(.theme--light) .singleListing {\n  border-top: 1px solid #dddddd;\n}\n:global(.theme--dark) .singleListing {\n  border-top: 1px solid #2f2f2f;\n}\n\n.singleListing[data-no-border=true] {\n  border: none;\n}\n\n.xContainer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-start;\n  cursor: pointer;\n  width: 30px;\n  align-self: stretch;\n}\n.xContainer div {\n  display: flex;\n  align-items: center;\n  padding: 2px;\n  justify-content: center;\n  border-radius: 6px;\n  transition: 200ms;\n}\n:global(.theme--light) .xContainer div {\n  background: #dddddd;\n}\n:global(.theme--dark) .xContainer div {\n  background: #2f2f2f;\n}\n:global(.theme--light) .xContainer div:hover {\n  background: #888888;\n}\n:global(.theme--dark) .xContainer div:hover {\n  background: #a3a3a3;\n}\n\n.itemTextPrimary {\n  font-size: 1.4rem;\n  font-weight: 500;\n}\n\n.secRowSeat {\n  flex-grow: 1;\n  min-width: 20px;\n}\n\n.headerSecRowSeat {\n  padding: 0.6rem;\n}\n\n.secRowSeatCont {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.textSecondary {\n  font-size: 1.2rem;\n  font-weight: 400;\n}\n:global(.theme--light) .textSecondary {\n  color: #888888;\n}\n:global(.theme--dark) .textSecondary {\n  color: #a3a3a3;\n}\n\n.qty {\n  width: 45px;\n  padding: 0.6rem;\n  flex-shrink: 0;\n}\n:global(.theme--light) .qty {\n  color: #888888;\n}\n:global(.theme--dark) .qty {\n  color: #a3a3a3;\n}\n\n.costLabel {\n  width: 90px;\n  padding: 0.6rem;\n  flex-shrink: 0;\n  text-align: right;\n}\n:global(.theme--light) .costLabel {\n  color: #888888;\n}\n:global(.theme--dark) .costLabel {\n  color: #a3a3a3;\n}\n\n.loaderWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 520px;\n  width: 1200px;\n  max-width: 100%;\n}\n\n.inputWithAction {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.copyButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 34px;\n  height: 34px;\n  border-radius: 6px;\n  cursor: pointer;\n  background: none;\n}\n:global(.theme--light) .copyButton {\n  border: 1px solid #dddddd;\n  color: #888888;\n}\n:global(.theme--dark) .copyButton {\n  border: 1px solid #2f2f2f;\n  color: #a3a3a3;\n}\n.copyButton:disabled {\n  cursor: default;\n  opacity: 0.5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `BulkInternalNotes-module_root___U68LX`,
	"top": `BulkInternalNotes-module_top___SzvWF`,
	"left": `BulkInternalNotes-module_left___LID7C`,
	"right": `BulkInternalNotes-module_right___JsN5e`,
	"section": `BulkInternalNotes-module_section___TN2QT`,
	"subHeader": `BulkInternalNotes-module_subHeader___wRi7j`,
	"subHeaderSecondary": `BulkInternalNotes-module_subHeaderSecondary___p1A5j`,
	"description": `BulkInternalNotes-module_description___kpNEH`,
	"label": `BulkInternalNotes-module_label___HzeWK`,
	"fieldsGrid": `BulkInternalNotes-module_fieldsGrid___GyYY6`,
	"maskedFieldsRow": `BulkInternalNotes-module_maskedFieldsRow___hIDwx`,
	"field": `BulkInternalNotes-module_field___p4pDW`,
	"fieldFull": `BulkInternalNotes-module_fieldFull___xcyVw`,
	"input": `BulkInternalNotes-module_input___DJmbK`,
	"textArea": `BulkInternalNotes-module_textArea___wXnvd`,
	"smallTextArea": `BulkInternalNotes-module_smallTextArea___S0_66`,
	"toggles": `BulkInternalNotes-module_toggles___H84m2`,
	"toggle": `BulkInternalNotes-module_toggle___YGnCM`,
	"warning": `BulkInternalNotes-module_warning___lUQDp`,
	"warningHeader": `BulkInternalNotes-module_warningHeader___I1VAD`,
	"warningText": `BulkInternalNotes-module_warningText___sbMQE`,
	"rightTopHeaders": `BulkInternalNotes-module_rightTopHeaders___rwKcv`,
	"summaryRow": `BulkInternalNotes-module_summaryRow___piPEv`,
	"summaryRowLabel": `BulkInternalNotes-module_summaryRowLabel___LTip3`,
	"summaryRowValue": `BulkInternalNotes-module_summaryRowValue___kv5WA`,
	"summaryRowValuePositive": `BulkInternalNotes-module_summaryRowValuePositive___K1whH`,
	"summaryRowValueDisabled": `BulkInternalNotes-module_summaryRowValueDisabled___DPSF9`,
	"buttons": `BulkInternalNotes-module_buttons___SUKFp`,
	"listings": `BulkInternalNotes-module_listings___RggLu`,
	"singleListing": `BulkInternalNotes-module_singleListing___LRiH0`,
	"xContainer": `BulkInternalNotes-module_xContainer___YucWz`,
	"itemTextPrimary": `BulkInternalNotes-module_itemTextPrimary___vxEK9`,
	"secRowSeat": `BulkInternalNotes-module_secRowSeat___tTzRG`,
	"headerSecRowSeat": `BulkInternalNotes-module_headerSecRowSeat___TIs3u`,
	"secRowSeatCont": `BulkInternalNotes-module_secRowSeatCont___j26Zj`,
	"textSecondary": `BulkInternalNotes-module_textSecondary___DAKEq`,
	"qty": `BulkInternalNotes-module_qty____XE1Z`,
	"costLabel": `BulkInternalNotes-module_costLabel___HFpli`,
	"loaderWrapper": `BulkInternalNotes-module_loaderWrapper___q80Go`,
	"inputWithAction": `BulkInternalNotes-module_inputWithAction___XW2vF`,
	"copyButton": `BulkInternalNotes-module_copyButton___ZFGkb`
};
export default ___CSS_LOADER_EXPORT___;
